import React from "react";
import { useUser } from "~/Context/userContext";
import LoginModal from "@dreamchimney/user-login";
import Auth from "./Auth";
import { Link } from "react-router-dom";

const HeaderLogin = (props) => {
  const { state: userState, dispatch } = useUser();

  const loginToggle = () => dispatch({ type: "signin_open" });
  // const logoutHandler = () => dispatch({ type: "logout", payload: {} });

  const handleLoginAction = (payload) => {
    const { dispatch: payloadDispatch = {} } = payload;
    dispatch(payloadDispatch);
  };

  const modalClosed = (result = {}) => {
    if (Object.keys(result).length === 0) {
      dispatch({ type: "signin_close" });
    } else if (result.isChim === false) {
      dispatch({ type: "user_login", payload: { user: result.user } });
    } else {
      dispatch({ type: "login", payload: { user: result.user } });
    }
  };
  if (!userState) return null;

  return (
    <div className="loginWelcome">
      <Auth className="">
        <ul>
          <li className="first last">
            {userState.loggedin && userState.isChim && userState.user && (
              <span>
                Welcome <Link to={`/profile/${userState.user.dir}`}>{userState.user.full_name} Chimney</Link>
              </span>
            )}
            {userState.loggedin && !userState.isChim && <span>Welcome {userState.user.full_name}</span>}
            {!userState.loggedin && (
              <span className="login" onClick={() => loginToggle()}>
                Login
              </span>
            )}
          </li>
        </ul>
        <LoginModal show={userState.signin} onClose={modalClosed} onLoggedin={handleLoginAction} onRegister={handleLoginAction} />
      </Auth>
    </div>
  );
};

export default HeaderLogin;
